import { ApiClient } from './lib/ApiClient';

export const apiClients: {
	streamerApi?: ApiClient;
	twitchHelixApi?: ApiClient;
} = {};

export const initStreamerApi = (): void => {
	apiClients.streamerApi = new ApiClient({
		baseUrl: import.meta.env.VITE_STREAMER_API_BASE_URL,
		authorizationHeaderName: 'authorization-twitch',
	});

	apiClients.twitchHelixApi = new ApiClient({
		baseUrl: import.meta.env.VITE_TWITCH_HELIX_API_BASE_URL,
	});
};
